import './apps/navigation/src/polyfills.ts';